/**
 * OrganizationIcon — a building: the organization. Hugeicons building (MIT).
 */

import svg from './svg/organization.svg?raw';
import { makeSvgIcon } from './svgIcon';

export const OrganizationIcon = makeSvgIcon('organization', svg);
